<template>
  <div class="oauth-wrapper">
    <div class="oauth">
      <div class="oauth-avatar">
        <i class="oauth-avatar__icon">
          <img :src="appInfo.appLogoUrl" alt="">
        </i>
        <i class="oauth-avatar__arrow">
          <icon-font type="gb-icon-shouquan" />
        </i>
        <i class="oauth-avatar__icon"><img src="@/assets/blogo.png" alt=""></i>
        <b>{{ appInfo.appName }}请求登录你的ECCANG账号</b>
      </div>
      <div class="oauth-compony">
        <div class="oauth-subtitle">你将以该身份登录</div>
        <div class="oauth-compony-item" v-if="!authenticationCode">
          <i><img src="~@/assets/171559.png" alt=""></i>
          <div class="oauth-compony-item__content">
            <b>{{ userInfo.onlineSubjectName || '个人企业' }}</b>
            <span>{{ userInfo.realName || userInfo.phone || userInfo.userName }}</span>
          </div>
        </div>
        <div class="oauth-compony-radio-warpper" v-else>
          <div class="oauth-compony-item" v-for="item in subjectDTOS" :key="item.subjectId">
            <a href="javascript:void(0);" @click="subjectId = item.subjectId" :class="{ checked: item.subjectId === subjectId }"></a>
            <i><img src="~@/assets/171559.png" alt=""></i>
            <div class="oauth-compony-item__content">
              <b>{{ item.companyName }}</b>
              <span>{{ item.userName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="oauth-info">
        <div class="oauth-subtitle">将获取以下权限</div>
        <div class="oauth-info__item">
          <p>获取你的姓名，头像</p>
        </div>
      </div>
    </div>
    <div class="btns" v-if="appInfo.appId">
      <a-button type="default" @click="refuse">拒绝</a-button>
      <a-button type="primary" @click="toAuth" :loading="loading">授权</a-button>
    </div>
  </div>
</template>

<script>
import { appStoreLoginByToken, appStoreChooseSubject } from '@/api/sso/user'
import { queryThirdAppSimple } from '@/api/index'
import { mapGetters } from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  data () {
    return {
      loading: false,
      appInfo: {},
      token: this.$ls.get(ACCESS_TOKEN),
      authenticationCode: this.$route.query.authenticationCode,
      radioStyle: {
        display: 'block',
        lineHeight: '30px'
      },
      subjectId: this.$store.state.user.authLoginParams?.subjectDTOS?.[0]?.subjectId
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    subjectDTOS () {
      const subjectDTOS = this.$store.state.user.authLoginParams?.subjectDTOS
      return subjectDTOS || []
    }
  },
  mounted () {
    queryThirdAppSimple({
      appId: this.$route.query.appId
    }).then(res => {
      this.appInfo = res.data
    })
    if (!this.token && (!this.$route.query.authenticationCode || !this.subjectDTOS.length)) {
      this.$router.push({
        path: '/oauth/login',
        query: this.$route.query
      })
    }
  },
  methods: {
    toAuth () {
      const {
        appId,
        permissions,
        redirectUri,
        responseType,
        authenticationCode
      } = this.$route.query
      const api = this.subjectId ? appStoreChooseSubject : appStoreLoginByToken
      const urlRegex = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?/
      const redirect = decodeURIComponent(redirectUri).replace(/^(^\/\/)|(http[s]?:\/\/)?/, window.location.protocol + '//')
      console.log('redirect', redirect, urlRegex.test(redirect))
      if (!urlRegex.test(redirect)) {
        return this.$message.error('redirectUri格式错误')
      }
      const redirectUriDomain = new URL(redirect)
      const params = this.subjectId ? {
        appId,
        subjectId: this.subjectId,
        authenticationCode,
        redirectUriDomain: redirectUriDomain.hostname
      } : {
        appId,
        permissions: (permissions || 'BASE_INFO').split(','),
        redirectUriDomain: redirectUriDomain.hostname,
        responseType: responseType || 'code',
        systemCode: 'SSO_SYS_USER'
      }
      this.loading = true
      api(params).then(({ data }) => {
        this.$message.success('授权成功')
        const params = `${ /\?/.test(redirect) ? '&' : '?' }` + `client=pc&ec_code=${data.code}`
        window.location.replace(redirect + params, '_self')
      }).finally(() => {
        this.loading = false
      })
    },
    refuse () {
      window.opener = window
      let win = window.open('', '_self')
      win.close()
    }
  }
}
</script>

<style lang="less" scoped>
.oauth-wrapper {
  width: 484px;
  position: fixed;
  left: 50%;
  top: 60px;
  transform: translate(-50%, 0);
}
.oauth {
  border-radius: 4px;
  border: 1px solid #D8D8D8;
  overflow: hidden;
  padding: 0 23px;
  min-height: 459px;
  &-subtitle {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 18px;
    margin: 15px 0 9px 0;
  }
  &-avatar {
    margin-top: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    &__icon {
      width: 54px;
      height: 54px;
      border-radius: 8px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%
      }
    }
    &__arrow {
      font-size: 30px;
      color: rgba(0, 0, 0, 0.45);
      margin: 0 17px;
    }
    b {
      margin-top: 16px;
      flex: 0 0 100%;
      width: 100%;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
  }
  &-compony {
    margin-top: 50px;
    &-radio-warpper {
      max-height: 200px;
      overflow: hidden;
      overflow-y: auto;
    }
    &-item {
      display: flex;
      padding-top: 17px;
      padding-bottom: 17px;
      border-bottom: 1px solid #E8E8E8;
      a {
        flex: 0 0 15px;
        margin-top: 13px;
        margin-right: 10px;
        width: 15px;
        height: 15px;
        background: #fff;
        border-radius: 50%;
        border: 1px #ddd solid;
        position: relative;
        &.checked {
          background: @color;
          border-color: @color;
          &::before {
            position: absolute;
            display: block;
            content: '';
            width: 6px;
            height: 6px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            border-radius: 50%;
          }
        }
      }
      i {
        flex: 0 0 42px;
        width: 42px;
        height: 42px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #D8D8D8;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
      &__content {
        display: inline-flex;
        flex-wrap: wrap;
        font-size: 14px;
        margin-left: 12px;
        b {
          flex: 0 0 100%;
          width: 100%;
          color: rgba(0, 0, 0, 0.85);
        }
        span {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
  }
  &-info {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 50px;
    &__item {
      flex: 0 0 100%;
      width: 100%;
      font-size: 16px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.85);
      display: inline-flex;
      align-items: center;
      p {
        margin: 0;
      }
      &::before {
        content: '';
        display: block;
        position: relative;
        width: 8px;
        height: 8px;
        background: rgba(0, 0, 0, 0.25);
        border-radius: 50%;
        line-height: 24px;
        margin-right: 8px;
      }
    }
  }
}

.btns {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  button {
    margin-left: 12px;
  }
}
</style>
